import React, { Component } from 'react';

class PrivacyPolicyMain extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sta: '1',
      message: "",
      recruitData: [],
    }
  }

  initData() {
    {
      let res = {
        "message": "请求数据成功",
        "c_recruit": [
          {
            "contents": "SUN FLOWER SOFT株式会社（以下「当社」という。）は、IT事業において取扱う個人情報の保護について、社会的責任を十分に認識して、本人の権利利益を保護し、個人情報に関する法規制等を遵守いたします。",
            "id": "1",
            "contTitle": ""
          },
          {
            "contents": "また、以下に示す方針を具現化するために、個人情報保護マネジメントシステムを構築し、最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、その継続的な改善に、全社を挙げて取り組むことをここに宣言いたします。",
            "id": "2",
            "contTitle": ""
          },
          {
            "contents": "|ａ）当社事業、並びに従業員の雇用、人事管理等において取扱う個人情報について、予め特定された利用目的の範囲内において、個人情報の適切な取得・利用および提供を行い、利用目的の達成に必要な範囲を超えた個人情報の取扱い(目的外利用)は行いません。また、そのための適切な措置を講じます。",
            "id": "3",
            "contTitle": ""
          },
          {
            "contents": "|ｂ）当社は個人情報の取扱いに関する法令、国が定める指針およびその他の規範を遵守いたします。",
            "id": "4",
            "contTitle": ""
          },
          {
            "contents": "|ｃ）当社は個人情報への不正アクセス、個人情報の漏えい、滅失またはき損等のリスクに対しては、合理的な安全対策を講じ、事業の実情に合致した経営資源を注入し、個人情報のセキュリティ体制を継続的に向上させていきます。また不適切な事項については是正を行うなどの内部規程を定め、個人情報を最善の状態で保護いたします。",
            "id": "5",
            "contTitle": ""
          },
          {
            "contents": "|ｄ）当社は個人情報の取扱いに関する苦情および相談対応への内部規程を定め、苦情および相談には、迅速かつ誠実に対応いたします。",
            "id": "6",
            "contTitle": ""
          },
          {
            "contents": "|ｅ）個人情報保護マネジメントシステムについて、当社を取り巻く環境の変化を踏まえ、適時・適切に見直して、その改善を継続的に推進していきます。",
            "id": "7",
            "contTitle": ""
          },
          {
            "contents": "本方針は、全役員並びに従業員に配布して周知徹底させるとともに、いつでも、どなた様でも入手可能な措置を講ずるものとします。",
            "id": "8",
            "contTitle": ""
          },
        ]
      }
      res.contentArr = res.c_recruit
      delete res.c_recruit
      let recruitData = [];
      recruitData[0] = { contentArr: res.contentArr }
      this.setState({ "recruitData": recruitData })
    }
  }

  componentDidMount() {
    this.initData()
      window.scrollTo(0, 0);
  }
  render() {
    // 社員採用
    let recruitList = this.state.recruitData.map((recruit) => {
      // 主标题
      let titleItem = (
        <div className="privacy-policy-title">
          <h1>個人情報保護方針</h1>
        </div>
      );
      // 日期信息
      let dateInfo = (
        <div className="privacy-policy-right-container">
          <div className="privacy-policy-right">
            <p>制定日：2025年9月1日</p>
            <p>最終改定日：2025年9月1日</p>
          </div>
        </div>
      )
      //署名
      let nameInfo = (
        <div className="privacy-policy-right-container">
          <div className="privacy-policy-right">
            <p>SUN FLOWER SOFT株式会社</p>
            <p>代表取締役　陳　磊</p>
          </div>
        </div>
      )
      //联系方式
      let contactInfo = (
        <div className="privacy-policy-left-container">
          <div className="privacy-policy-left">
            <p>SUN FLOWER SOFT株式会社　お問合せ窓口</p>
            <p>info@sunflower-soft.com</p>
          </div>
        </div>
      )

      let contentItems = recruit.contentArr.map((cont) => {
        // 处理普通内容项
        let contenA = cont.contents.split('|');
        let num = 0;
        const content = contenA.map((content, key) => {
          if (contenA[0] === content) {
            return <span key={key}><p className="title">{cont.contTitle}</p>{content}</span>
          } else {
            num++;
            return <p key={num} style={{ paddingLeft: 30 }}>{content}</p>
          }
        })

        return (<li key={cont.id}>{content}</li>)
      }).filter(item => item !== null); // 过滤掉null值

      return (
        <div className="content" key={1}>
          {titleItem}
          {dateInfo}
          <ol key="recruit.id">
            {contentItems}
          </ol>
          <br />
          <br />
          {nameInfo}
          <br />
          {contactInfo}
          <div className="privacy-policy-right-container">
            <br />
            <div className="privacy-policy-right">
              <p>以上</p>
            </div>
          </div>
        </div>
      )
    })

    return (
      <div className="main-privacyPolicy" >
        <div className="layui-container">
          <div className="layui-row">
            {/* 社員採用 */}
            <div className="text">
              {recruitList}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicyMain
